'use client'

import type { ReactNode } from 'react'
import { Button } from '@/General/Button'
import { tracking } from '@/tracking'
import { SIGNUP_PRODUCT } from '../config'
import { SESSION_BUTTON_CLASS } from '../styles'

export type SessionRegistrationPlacement =
  | 'header'
  | 'ticket-comparison'
  | 'introduction'
  | 'performers'
  | 'vip'
  | 'final'
  | 'sticky'

type SessionRegistrationButtonProps = {
  children: ReactNode
  placement: SessionRegistrationPlacement
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export const SESSION_REGISTRATION_PATH = `/magic-conventions/${SIGNUP_PRODUCT}/register/`

export function SessionRegistrationButton({
  children,
  placement,
  className,
  size = 'md',
}: SessionRegistrationButtonProps) {
  return (
    <Button
      href={SESSION_REGISTRATION_PATH}
      className={`${SESSION_BUTTON_CLASS} ${className || ''}`}
      size={size}
      onClick={() =>
        tracking.track('Clicked convention registration CTA', {
          conventionSlug: 'the-session',
          conventionProductSlug: SIGNUP_PRODUCT,
          placement,
          destinationUrl: SESSION_REGISTRATION_PATH,
        })
      }
    >
      {children}
    </Button>
  )
}
